import React from 'react';
import { useTheme } from '@material-ui/core';

interface ConfirmationCheckProps {
  className?: string;
}

const ConfirmationCheck = ({ className }: ConfirmationCheckProps) => {
  const { secondary } = useTheme().palette;

  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M43 85.5C37.0972 85.5 31.5583 84.3889 26.3833 82.1667C21.2111 79.9444 16.7153 76.9236 12.8958 73.1042C9.07639 69.2847 6.05556 64.7889 3.83333 59.6167C1.61111 54.4417 0.5 48.9028 0.5 43C0.5 37.0972 1.61111 31.5583 3.83333 26.3833C6.05556 21.2111 9.07639 16.7153 12.8958 12.8958C16.7153 9.07639 21.2111 6.05556 26.3833 3.83333C31.5583 1.61111 37.0972 0.5 43 0.5C47.5139 0.5 51.7847 1.14167 55.8125 2.425C59.8403 3.71111 63.5556 5.5 66.9583 7.79167L60.0833 14.875C57.5833 13.3472 54.9097 12.1486 52.0625 11.2792C49.2153 10.4125 46.1944 9.97917 43 9.97917C33.8333 9.97917 26.0389 13.1903 19.6167 19.6125C13.1917 26.0375 9.97917 33.8333 9.97917 43C9.97917 52.1667 13.1917 59.9625 19.6167 66.3875C26.0389 72.8097 33.8333 76.0208 43 76.0208C52.1667 76.0208 59.9625 72.8097 66.3875 66.3875C72.8097 59.9625 76.0208 52.1667 76.0208 43C76.0208 41.8889 75.9694 40.7611 75.8667 39.6167C75.7611 38.4694 75.5694 37.3403 75.2917 36.2292L83 28.5208C83.8333 30.7431 84.4583 33.0694 84.875 35.5C85.2917 37.9306 85.5 40.4306 85.5 43C85.5 48.9028 84.3889 54.4417 82.1667 59.6167C79.9444 64.7889 76.9236 69.2847 73.1042 73.1042C69.2847 76.9236 64.7889 79.9444 59.6167 82.1667C54.4417 84.3889 48.9028 85.5 43 85.5ZM37.0625 62.6875L19.0417 44.5625L25.5 38L37.0625 49.6667L78.9375 7.58333L85.5 14.1458L37.0625 62.6875Z"
        fill={secondary.main}
      />
    </svg>
  );
};

ConfirmationCheck.defaultProps = {
  className: '',
};

export default ConfirmationCheck;
